export default __webpack_public_path__ + "static/media/0022.b59c2c3c.jpg";